import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Tooltip } from "@material-ui/core";
import { ReactComponent as GenerateExcelIcon } from "../../assets/generateExcel.svg";
import { toastInfo, toastFail } from "../../utilities/toast";
import download from "downloadjs";

interface ExcelDownloadMenuProps {
  requestId: number;
  pharmacyId: number;
  pharmacyName: string;
  availableReports: string[];
  getMethod: (url: string, config?: any) => Promise<any>;
}

const ExcelDownloadMenu: React.FC<ExcelDownloadMenuProps> = ({
  requestId,
  pharmacyId,
  pharmacyName,
  availableReports,
  getMethod,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const options = [
    { label: "Return Report", type: "RETURN-REPORT" },
    { label: "Schedule II", type: "SCHEDULE-2" },
    { label: "Schedule III-V", type: "SCHEDULE-345" },
  ];

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleDownload = async (reportType: string) => {
     handleClose();
     toastInfo(`Generating ${reportType}`);
     try {
        const response = await getMethod(
           `/pharmacies/${pharmacyId}/returnrequests/${requestId}/excel?reportType=${reportType}`,
           { responseType: 'blob' }
        );

        if (response && response.status >= 400) {
           toastFail(`Failed to generate ${reportType} report!`);
        } else {
           const contentType = response.headers['content-type'] as string;
           const contentDisposition = response.headers[
              'content-disposition'
           ] as string;

           const filename = contentDisposition
              ?.split('filename=')[1]
              ?.replace(/["']/g, '');

           download(response.data, filename, contentType);
        }
     } catch (error) {
        toastFail(`Error generating ${reportType}!`);
        console.error(error);
     }
  };

  return (
    <>
      <IconButton onClick={handleClick} style={{ padding: 4 }}>
        <GenerateExcelIcon
          title="Generate Excel"
          style={{ width: "40px", height: "40px" }}
        />
      </IconButton>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
        {options.map((option) => {
          const isDisabled = !availableReports.includes(option.type);
          return (
            <Tooltip
              key={option.type}
              title={
                isDisabled
                  ? "This report is not available for this request"
                  : ""
              }
              placement="left"
            >
              <div>
                <MenuItem
                  disabled={isDisabled}
                  onClick={() => handleDownload(option.type)}
                >
                  {option.label}
                </MenuItem>
              </div>
            </Tooltip>
          );
        })}
      </Menu>
    </>
  );
};

export default ExcelDownloadMenu;
